import { render } from "./PdfPreview.vue?vue&type=template&id=99370c6e&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"

import "./PdfPreview.vue?vue&type=style&index=0&id=99370c6e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99370c6e"]])

export default __exports__